"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var playerMethods = {
  on: 'on',
  off: 'off',
  preload: 'preload',
  init: 'init',
  load: 'load',
  play: 'play',
  seek: 'seek',
  pause: 'pause',
  stop: 'stop',
  unload: 'unload',
  destroy: 'destroy',
  setVolume: 'setVolume',
  getVolume: 'getVolume',
  setTitle: 'setTitle',
  getTimes: 'getTimes',
  canChangePlaybackRate: 'canChangePlaybackRate',
  getPlaybackRate: 'getPlaybackRate',
  changePlaybackRate: 'changePlaybackRate',
  requestInstreamAds: 'requestInstreamAds',
  toggleMute: 'toggleMute'
};
var _default = exports["default"] = playerMethods;
//# sourceMappingURL=playerMethods.js.map